"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3820,1259],{

/***/ 13820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "auth": function() { return /* binding */ auth; },
/* harmony export */   "initializeAuth": function() { return /* binding */ initializeAuth; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30137);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var firebase_auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91259);
/* harmony import */ var _util_platform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51295);
/* harmony import */ var _app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64097);
/* provided dependency */ var process = __webpack_require__(34155);
/* eslint-disable @blumintinc/blumint/require-dynamic-firebase-imports */ 




var app = (0,_app__WEBPACK_IMPORTED_MODULE_2__/* .getApp */ .Mq)();
// eslint-disable-next-line import/no-mutable-exports
var auth;
var initializeAuth = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__._)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!auth) return [
                        3,
                        2
                    ];
                    auth = (0,firebase_auth__WEBPACK_IMPORTED_MODULE_0__.getAuth)(app);
                    // Connect emulator after persistence is set
                    if (process.env.NEXT_PUBLIC_EMULATOR_MODE === "true") {
                        auth.settings.appVerificationDisabledForTesting = true;
                        (0,firebase_auth__WEBPACK_IMPORTED_MODULE_0__.connectAuthEmulator)(auth, "http://localhost:9099");
                    }
                    if (process.env.PLAYWRIGHT_TEST === "true") {
                        auth.settings.appVerificationDisabledForTesting = true;
                    }
                    // Set persistence first before any other operations
                    return [
                        4,
                        (0,firebase_auth__WEBPACK_IMPORTED_MODULE_0__.setPersistence)(auth, (0,_util_platform__WEBPACK_IMPORTED_MODULE_1__/* .detectPlatform */ .tz)() === "browser" ? firebase_auth__WEBPACK_IMPORTED_MODULE_0__.browserLocalPersistence : firebase_auth__WEBPACK_IMPORTED_MODULE_0__.indexedDBLocalPersistence)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        auth
                    ];
            }
        });
    });
    return function initializeAuth() {
        return _ref.apply(this, arguments);
    };
}();
// Initialize auth immediately
initializeAuth().catch(console.error);



/***/ }),

/***/ 91259:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ActionCodeOperation": function() { return /* reexport */ index_68602d24.A; },
  "ActionCodeURL": function() { return /* reexport */ index_68602d24.ai; },
  "AuthCredential": function() { return /* reexport */ index_68602d24.L; },
  "AuthErrorCodes": function() { return /* reexport */ index_68602d24.I; },
  "EmailAuthCredential": function() { return /* reexport */ index_68602d24.M; },
  "EmailAuthProvider": function() { return /* reexport */ index_68602d24.V; },
  "FacebookAuthProvider": function() { return /* reexport */ index_68602d24.W; },
  "FactorId": function() { return /* reexport */ index_68602d24.F; },
  "GithubAuthProvider": function() { return /* reexport */ index_68602d24.Y; },
  "GoogleAuthProvider": function() { return /* reexport */ index_68602d24.X; },
  "OAuthCredential": function() { return /* reexport */ index_68602d24.N; },
  "OAuthProvider": function() { return /* reexport */ index_68602d24.Z; },
  "OperationType": function() { return /* reexport */ index_68602d24.O; },
  "PhoneAuthCredential": function() { return /* reexport */ index_68602d24.Q; },
  "PhoneAuthProvider": function() { return /* reexport */ index_68602d24.P; },
  "PhoneMultiFactorGenerator": function() { return /* reexport */ index_68602d24.m; },
  "ProviderId": function() { return /* reexport */ index_68602d24.p; },
  "RecaptchaVerifier": function() { return /* reexport */ index_68602d24.R; },
  "SAMLAuthProvider": function() { return /* reexport */ index_68602d24._; },
  "SignInMethod": function() { return /* reexport */ index_68602d24.S; },
  "TotpMultiFactorGenerator": function() { return /* reexport */ index_68602d24.T; },
  "TotpSecret": function() { return /* reexport */ index_68602d24.n; },
  "TwitterAuthProvider": function() { return /* reexport */ index_68602d24.$; },
  "applyActionCode": function() { return /* reexport */ index_68602d24.a7; },
  "beforeAuthStateChanged": function() { return /* reexport */ index_68602d24.x; },
  "browserLocalPersistence": function() { return /* reexport */ index_68602d24.b; },
  "browserPopupRedirectResolver": function() { return /* reexport */ index_68602d24.k; },
  "browserSessionPersistence": function() { return /* reexport */ index_68602d24.a; },
  "checkActionCode": function() { return /* reexport */ index_68602d24.a8; },
  "confirmPasswordReset": function() { return /* reexport */ index_68602d24.a6; },
  "connectAuthEmulator": function() { return /* reexport */ index_68602d24.K; },
  "createUserWithEmailAndPassword": function() { return /* reexport */ index_68602d24.aa; },
  "debugErrorMap": function() { return /* reexport */ index_68602d24.G; },
  "deleteUser": function() { return /* reexport */ index_68602d24.E; },
  "fetchSignInMethodsForEmail": function() { return /* reexport */ index_68602d24.af; },
  "getAdditionalUserInfo": function() { return /* reexport */ index_68602d24.aq; },
  "getAuth": function() { return /* reexport */ index_68602d24.o; },
  "getIdToken": function() { return /* reexport */ index_68602d24.an; },
  "getIdTokenResult": function() { return /* reexport */ index_68602d24.ao; },
  "getMultiFactorResolver": function() { return /* reexport */ index_68602d24.as; },
  "getRedirectResult": function() { return /* reexport */ index_68602d24.j; },
  "inMemoryPersistence": function() { return /* reexport */ index_68602d24.U; },
  "indexedDBLocalPersistence": function() { return /* reexport */ index_68602d24.i; },
  "initializeAuth": function() { return /* reexport */ index_68602d24.J; },
  "initializeRecaptchaConfig": function() { return /* reexport */ index_68602d24.t; },
  "isSignInWithEmailLink": function() { return /* reexport */ index_68602d24.ad; },
  "linkWithCredential": function() { return /* reexport */ index_68602d24.a2; },
  "linkWithPhoneNumber": function() { return /* reexport */ index_68602d24.l; },
  "linkWithPopup": function() { return /* reexport */ index_68602d24.d; },
  "linkWithRedirect": function() { return /* reexport */ index_68602d24.g; },
  "multiFactor": function() { return /* reexport */ index_68602d24.at; },
  "onAuthStateChanged": function() { return /* reexport */ index_68602d24.y; },
  "onIdTokenChanged": function() { return /* reexport */ index_68602d24.w; },
  "parseActionCodeURL": function() { return /* reexport */ index_68602d24.aj; },
  "prodErrorMap": function() { return /* reexport */ index_68602d24.H; },
  "reauthenticateWithCredential": function() { return /* reexport */ index_68602d24.a3; },
  "reauthenticateWithPhoneNumber": function() { return /* reexport */ index_68602d24.r; },
  "reauthenticateWithPopup": function() { return /* reexport */ index_68602d24.e; },
  "reauthenticateWithRedirect": function() { return /* reexport */ index_68602d24.h; },
  "reload": function() { return /* reexport */ index_68602d24.ar; },
  "revokeAccessToken": function() { return /* reexport */ index_68602d24.D; },
  "sendEmailVerification": function() { return /* reexport */ index_68602d24.ag; },
  "sendPasswordResetEmail": function() { return /* reexport */ index_68602d24.a5; },
  "sendSignInLinkToEmail": function() { return /* reexport */ index_68602d24.ac; },
  "setPersistence": function() { return /* reexport */ index_68602d24.q; },
  "signInAnonymously": function() { return /* reexport */ index_68602d24.a0; },
  "signInWithCredential": function() { return /* reexport */ index_68602d24.a1; },
  "signInWithCustomToken": function() { return /* reexport */ index_68602d24.a4; },
  "signInWithEmailAndPassword": function() { return /* reexport */ index_68602d24.ab; },
  "signInWithEmailLink": function() { return /* reexport */ index_68602d24.ae; },
  "signInWithPhoneNumber": function() { return /* reexport */ index_68602d24.s; },
  "signInWithPopup": function() { return /* reexport */ index_68602d24.c; },
  "signInWithRedirect": function() { return /* reexport */ index_68602d24.f; },
  "signOut": function() { return /* reexport */ index_68602d24.C; },
  "unlink": function() { return /* reexport */ index_68602d24.ap; },
  "updateCurrentUser": function() { return /* reexport */ index_68602d24.B; },
  "updateEmail": function() { return /* reexport */ index_68602d24.al; },
  "updatePassword": function() { return /* reexport */ index_68602d24.am; },
  "updatePhoneNumber": function() { return /* reexport */ index_68602d24.u; },
  "updateProfile": function() { return /* reexport */ index_68602d24.ak; },
  "useDeviceLanguage": function() { return /* reexport */ index_68602d24.z; },
  "validatePassword": function() { return /* reexport */ index_68602d24.v; },
  "verifyBeforeUpdateEmail": function() { return /* reexport */ index_68602d24.ah; },
  "verifyPasswordResetCode": function() { return /* reexport */ index_68602d24.a9; }
});

// EXTERNAL MODULE: ./node_modules/@firebase/auth/dist/esm2017/index-68602d24.js
var index_68602d24 = __webpack_require__(37790);
// EXTERNAL MODULE: ./node_modules/@firebase/app/dist/esm/index.esm2017.js
var index_esm2017 = __webpack_require__(32238);
// EXTERNAL MODULE: ./node_modules/@firebase/util/dist/index.esm2017.js
var dist_index_esm2017 = __webpack_require__(74444);
// EXTERNAL MODULE: ./node_modules/@firebase/logger/dist/esm/index.esm2017.js
var esm_index_esm2017 = __webpack_require__(53333);
// EXTERNAL MODULE: ./node_modules/@firebase/component/dist/esm/index.esm2017.js
var dist_esm_index_esm2017 = __webpack_require__(8463);
;// CONCATENATED MODULE: ./node_modules/@firebase/auth/dist/esm2017/index.js






//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/firebase/auth/dist/esm/index.esm.js

//# sourceMappingURL=index.esm.js.map


/***/ })

}]);